module.exports = __webpack_public_path__ + "img/arriving-to-spain.221a190c.jpg";